"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = smallHeader;
function smallHeader() {
  return "\n    font-size: 10px;\n    text-transform: uppercase;\n    color: white;\n    font-weight: bold;\n  ";
}